// import { Box, Grid, makeStyles } from "@material-ui/core";
import styled from "@emotion/styled";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useNavigate } from "react-router-dom";
import Web3 from "web3";
import { addIcon, addNft, deleteIcon, searchIcon } from "../../../assets";
import { ON_LEND, REWARD_TOKEN_ADDRESS } from "../../../constants";
import {
  batchTransfer,
  getSigAndKey,
  lendNFT,
  verifyAndlendNFT,
} from "../../../contract";
import { ZERO_ADDRESS } from "../../../contract/contract-constant";
import { useAPIActions, useUIActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { tokens } from "../../../theme";
import FinalPreview from "./FinalPreview";
// import FinalPreview from "./FinalPreview";
import itemTypes from "./ItemTypes";

const AddNftBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px 7px 15px 7px",
  backgroundColor: theme.palette.secondary.dark,
  width: "144px",
  height: "162px",
  border: "0.5px solid #6A27EA",
  borderRadius: 14,
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  position: "relative",
}));

const ContentContainer = styled(Stack)({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  // flex: 1,
  alignItems: "flex-start",
  justifyContent: "flex-start",
  height: "80vh",

  // border: "1px solid red",
});
const Container = styled(Box)({
  // width: "70%",
  // display: "flex",
  // flexDirection: "column",
  maxHeight: "70vh",
  overflowY: "auto",
  overflowX: "hidden",
  paddingTop: "10px",
  marginLeft: 10,
  paddingRight: 10,
  marginRight: 20,
  marginTop: "15px",
  // flex: 3,
});

const PreviewBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  borderRight: "2px solid #E8ECF5",
  position: "relative",

  width: "30%",
  // height: "80vh",
});
const SelectedNftItem = ({
  nft,
  index,
  droppedNfts,
  setDroppedNfts,
  setSelectedNftCopy,
  selectedNftCopy,
  setProfileNfts,
  selectedNft,
}) => {
  const [{ isDragging }, dragRef] = useDrag(
    {
      type: itemTypes.CARD,
      item: { ...selectedNftCopy[index] },
      collect: (monitor) => {
        console.log("monitor", monitor, selectedNftCopy[index]);
        return {
          isDragging: !!monitor.isDragging(),
        };
      },
    },
    []
  );

  const [cover, setCover] = useState(10);
  return (
    <Box style={{ position: "relative", width: "144px", height: "160px" }}>
      <img
        src={deleteIcon}
        onClick={() => {
          setSelectedNftCopy(
            selectedNftCopy.filter((nftC) => nftC.tokenId !== nft.tokenId)
          );
          let copy = [...selectedNft];
          setProfileNfts(
            selectedNft.map((nftC) => {
              if (nftC.tokenId === nft.tokenId) {
                return { ...nftC, selected: false };
              } else {
                return nftC;
              }
            })
          );
        }}
        alt="delete"
        style={{
          position: "absolute",
          right: -10,
          top: -10,
          zIndex: cover,
        }}
      />
      <img
        ref={dragRef}
        src={nft.image}
        alt="avarik saga"
        onError={(e) =>
          (e.currentTarget.src =
            "https://testnets.opensea.io/static/images/placeholder.png")
        }
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 9,
          border: "1px solid #6A27EA",
          //   position: "absolute",
          //   left: 0,
          //   bottom: 0,
        }}
      />
    </Box>
  );
};

export default function PreviewAndSelectedNfts(props) {
  const {
    selectedNft,
    setSelectedNft,
    setProfileNfts,
    setStep,
    droppedNfts,
    setDroppedNfts,
    scholarAddress,
    setScholarAddress,
    split,
    setSplit,
    operation,
    searchVar,
    searchShow,
    filteredNfts,
    setFiltered,
    instances,
    addInstance,
    updateInstance,
    removeInstance,
    setInstances,
    currentInstance,
    setCurrentInstance,
  } = props;

  const navigate = useNavigate();
  const { setLoading, setSnackbar } = useUIActions();
  const { updateProfileNftsOnBulkLend } = useAPIActions();
  const { account, chainId } = useWeb3React();

  const { profileNfts, collectionWiseProfileNfts } = useTypedSelector(
    (state) => state.apiReducer
  );

  const [selectedNftCopy, setSelectedNftCopy] = useState(
    selectedNft.filter((nft) => nft.selected)
  );
  console.log("droppedNfts n", scholarAddress, droppedNfts);

  function getDifference(array1, array2) {
    return array1.filter((object1) => {
      return !array2.some((object2) => {
        return object1.tokenId === object2.tokenId;
      });
    });
  }

  useEffect(() => {
    let allDroppedNfts = [];
    instances.forEach(
      (ins) => (allDroppedNfts = allDroppedNfts.concat(ins.droppedNfts))
    );
    const res = getDifference(selectedNftCopy, allDroppedNfts);
    console.log("diff chala", res);
    setSelectedNftCopy(res);

    const tokenIds = selectedNft
      .filter((nft) => nft.selected)
      .map((nft) => nft.tokenId);
    const updatedInstancesForDroppedNft = instances.map((ins) => {
      let dropped = ins.droppedNfts.filter((nft) =>
        tokenIds.includes(nft.tokenId)
      );

      return {
        ...ins,
        droppedNfts: dropped,
      };
    });

    setInstances(updatedInstancesForDroppedNft);

    // setLoading(false);
  }, []);

  const updateDroppedState = (item) => {
    let copy = [...droppedNfts].concat(item);
    // setDroppedNfts(copy);
    updateInstance(currentInstance, {
      droppedNfts: [...instances[currentInstance].droppedNfts, item],
    });
    setSelectedNftCopy(
      selectedNftCopy.filter((nft) => nft.tokenId !== item.tokenId)
    );
  };

  const [{ isOver }, dropRef] = useDrop({
    accept: itemTypes.CARD,
    drop: (item) => updateDroppedState(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  console.log("selectedNftCopy", selectedNftCopy);

  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));

  const NftBoxProps = () => {
    if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(3, 2fr)",
        gridTemplateRows: "repeat(8, 1fr)",
        gap: "10px",
      };
    } else if (downXl) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(4, 2fr)",
        gridTemplateRows: "repeat(10, 1fr)",
        gap: "10px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(6, 2fr)",
        gridTemplateRows: "repeat(10, 1fr)",
        gap: "10px",
      };
    }
  };

  const validateAddress = (address) => {
    if (!Web3.utils.isAddress(address)) {
      return false;
    }
    return true;
  };

  const validateAddressesForSend = async () => {
    const allScholars = instances.map((ins) => ins.scholarAddress);
    // const allRta = instances.map((ins) => ins.rewardTokenAddress);
    console.log("allScholars", allScholars);

    const isScholarValid = await Promise.all(
      allScholars.map(async (scholar) => await validateAddress(scholar))
    );
    // const isRtaValid = await Promise.all(
    //   allRta.map(async (rta) => await validateAddress(rta))
    // );

    console.log("validate addresses", isScholarValid);

    if (isScholarValid.some((sch) => sch === false)) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Recipient Address is not valid!",
      });
      return false;
    }

    if (isScholarValid.every((sch) => sch === true)) {
      return true;
    }
  };

  const sendCallback = async (msg, status) => {
    setLoading(false);
    setSnackbar({
      open: true,
      severity: status ? "success" : "error",
      message: msg,
    });
    if (status) setStep(0);
    if (status) {
      let allDroppedNfts = [];
      instances.forEach(
        (ins) => (allDroppedNfts = allDroppedNfts.concat(ins.droppedNfts))
      );
      const nftsToUpdate = allDroppedNfts.map((nft) => nft.id);
      const tokenIdsOfnftsToUpdate = allDroppedNfts.map((nft) => nft.tokenId);

      let updProfileNfts = profileNfts.filter(
        (nft) => !nftsToUpdate.includes(nft.id)
      );

      await updateProfileNftsOnBulkLend(updProfileNfts, chainId);
      console.log("updProfileNfts", updProfileNfts);
      // updProfileNfts = updProfileNfts.map((nft) => {
      //   return { ...nft, selected: false };
      // });

      let updNfts =
        collectionWiseProfileNfts.filter(
          (collection) =>
            collection.address.toLowerCase() ===
            allDroppedNfts[0].nftAddress.toLowerCase()
        )[0].nfts || [];

      updNfts = updNfts.filter(
        (nft) => !tokenIdsOfnftsToUpdate.includes(nft.tokenId)
      );

      setDroppedNfts([]);
      setSelectedNftCopy([]);
      setSelectedNft([]);
      setInstances([
        {
          scholarAddress: "",
          rewardTokenAddress: "",
          split: "",
          droppedNfts: [],
        },
      ]);
      setCurrentInstance(0);
      setProfileNfts(updNfts);
    }
  };

  const onSend = async () => {
    try {
      const resp = await validateAddressesForSend();
      console.log("validateAddressesForSend()", resp);
      if (resp) {
        setLoading(true);
        let nftAddresses = [];
        let tokenIds = [];
        let toAddresses = [];
        instances.forEach((ins) => {
          toAddresses = toAddresses.concat(
            new Array(ins.droppedNfts.length).fill(ins.scholarAddress)
          );
          const allNftAddressOfAnInstance = ins.droppedNfts.map(
            (nft) => nft.nftAddress
          );
          nftAddresses = nftAddresses.concat(allNftAddressOfAnInstance);
          const allTokenIdsOfAnInstance = ins.droppedNfts.map(
            (nft) => nft.tokenId
          );
          tokenIds = tokenIds.concat(allTokenIdsOfAnInstance);
        });
        // const nftAddresses = droppedNfts.map((nft) => nft.nftAddress);
        // const tokenIds = droppedNfts.map((nft) => nft.tokenId);
        // const toAddresses = nftAddresses.map((nft) => scholarAddress);
        const amounts = nftAddresses.map((nft) => 0);
        console.log("params for batch transfer", {
          nftAddresses,
          toAddresses,
          tokenIds,
          amounts,
        });
        console.log("**************RUNNING BATCH TRANSFER NFT**************");
        await batchTransfer(
          nftAddresses,
          toAddresses,
          tokenIds,
          amounts,
          account,
          sendCallback
        );
      } else {
        setLoading(false);
        return;
      }
    } catch (e) {
      console.log("err in onconfirm", e);
      setLoading(false);
    }
  };

  return (
    <ContentContainer direction="row">
      <PreviewBox {...{ ref: dropRef }}>
        {[instances[currentInstance]].map((instance) => (
          <FinalPreview
            droppedNfts={instance.droppedNfts}
            scholarAddress={instance.scholarAddress}
            split={instance.split}
            rewardTokenAddress={instance.rewardTokenAddress}
            instance={instance}
            isOver={isOver}
            selectedNftCopy={selectedNftCopy}
            setSelectedNftCopy={setSelectedNftCopy}
            operation={operation}
            addInstance={() => {
              if (!validateAddress(instances[currentInstance].scholarAddress)) {
                setSnackbar({
                  open: true,
                  severity: "error",
                  message:
                    operation === "bulk-lend"
                      ? "Scholar Address is not valid!"
                      : "Recipient Address is not valid!",
                });
                return;
              } else if (
                !validateAddress(
                  instances[currentInstance].rewardTokenAddress
                ) &&
                operation === "bulk-lend"
              ) {
                setSnackbar({
                  open: true,
                  severity: "error",
                  message: "Yield Destination Address is not valid!",
                });
                return;
              }
              addInstance();
              setCurrentInstance(currentInstance + 1);
            }}
            updateInstance={updateInstance}
            removeInstance={removeInstance}
            currentInstance={currentInstance}
            setCurrentInstance={setCurrentInstance}
            instances={instances}
          />
        ))}
      </PreviewBox>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          width: "70%",
          height: "100%",
          // border: "1px solid pink",
        }}
      >
        <Box
          display="flex"
          backgroundColor={theme.palette.secondary.dark}
          borderRadius="3px"
          sx={{ ml: 1, mt: "15px", width: "90%" }}
        >
          <IconButton type="button" sx={{ p: 1 }}>
            <img src={searchIcon} alt="search" />
          </IconButton>
          <InputBase
            sx={{ ml: 2, fontSize: "14px" }}
            placeholder="Search By NFT Name"
            value={searchVar}
            onChange={(e) => setFiltered(e)}
          />
        </Box>
        <Container {...NftBoxProps()}>
          {searchShow && filteredNfts.length > 0 ? (
            selectedNftCopy.map((item, index) => {
              return (
                <Box gridColumn="span 1" gridRow="span 1" key={item.tokenId}>
                  <SelectedNftItem
                    nft={item}
                    index={index}
                    droppedNfts={droppedNfts}
                    setDroppedNfts={setDroppedNfts}
                    setSelectedNftCopy={setSelectedNftCopy}
                    selectedNftCopy={selectedNftCopy}
                    setProfileNfts={setProfileNfts}
                    selectedNft={selectedNft}
                  />
                </Box>
              );
            })
          ) : searchShow && filteredNfts.length === 0 ? (
            <></>
          ) : (
            selectedNftCopy.map((item, index) => {
              return (
                <Box gridColumn="span 1" gridRow="span 1" key={item.tokenId}>
                  <SelectedNftItem
                    nft={item}
                    index={index}
                    droppedNfts={droppedNfts}
                    setDroppedNfts={setDroppedNfts}
                    setSelectedNftCopy={setSelectedNftCopy}
                    selectedNftCopy={selectedNftCopy}
                    setProfileNfts={setProfileNfts}
                    selectedNft={selectedNft}
                  />
                </Box>
              );
            })
          )}
          <Box gridColumn="span 1" gridRow="span 1">
            <AddNftBox onClick={() => setStep(0)}>
              <img
                src={addIcon}
                alt="add box"
                style={{ width: "40px", height: "40px" }}
              />
            </AddNftBox>
          </Box>
        </Container>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            marginTop: "25px",
          }}
        >
          <Button
            onClick={() => onSend()}
            disabled={
              instances.find((ins) => ins.scholarAddress.length === 0) ||
              instances.find((ins) => ins.droppedNfts.length === 0)
            }
            sx={{
              width: "168px",
              height: "40px",
              border: `1px solid ${colors.primary[500]}`,
              color: colors.primary[500],
              backgroundColor: colors.whiteAccent[900],
              borderRadius: "7px",
              fontSize: "12px",
              fontWeight: 400,
              "&:hover": {
                color: colors.whiteAccent[900],
                backgroundColor: colors.primary[500],
              },
            }}
            variant={"outlined"}
          >
            Send
          </Button>

          {/* <img src={leftArrow} alt="left arrow" /> */}
        </Box>
      </Box>
    </ContentContainer>
  );
}
